var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M18 14a2 2 0 0 1 2 2v5H4v-5a2 2 0 0 1 2-2zM12 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }